import React, { useEffect } from "react";
import { FaShieldAlt, FaPhoneAlt, FaMapMarkerAlt, FaExclamationTriangle, FaCheckCircle } from "react-icons/fa";
import "../sell-fast-page/info-page.css";

const TIPS = [
  {
    icon: <FaPhoneAlt size={22} color="#ed1b24" />,
    title: "Communicate Safely",
    points: [
      "Use AdsOne's messaging features to communicate initially — avoid sharing personal details too early.",
      "Be cautious of buyers or sellers who are overly eager, pushy or refuse to meet in person.",
      "Never send money transfers or deposits before physically inspecting a vehicle.",
      "Ignore requests to move conversations off the platform to untraceable channels.",
    ],
  },
  {
    icon: <FaMapMarkerAlt size={22} color="#ed1b24" />,
    title: "Meet in a Safe Place",
    points: [
      "Always meet buyers or sellers in a public, well-lit location — a petrol station forecourt or busy car park is ideal.",
      "Bring a friend or family member with you when meeting a stranger.",
      "Avoid meeting at your home address or in isolated locations.",
      "Conduct test drives only in familiar, busy areas and always accompany the buyer.",
    ],
  },
  {
    icon: <FaShieldAlt size={22} color="#ed1b24" />,
    title: "Verify Before You Buy",
    points: [
      "Ask to see the vehicle's revenue licence, insurance certificate and registration document (CR book).",
      "Check that the chassis number and engine number on the documents match the vehicle.",
      "Use the DMT (Department of Motor Traffic) online service to verify ownership history.",
      "Have a trusted mechanic inspect the vehicle before finalising any payment.",
    ],
  },
  {
    icon: <FaExclamationTriangle size={22} color="#ed1b24" />,
    title: "Watch Out for Scams",
    points: [
      "Prices that seem far too good to be true usually are — treat them with suspicion.",
      "Be wary of sellers who claim to be overseas and want to ship the vehicle to you.",
      "Never pay for a vehicle you have not personally seen and inspected.",
      "Report suspicious listings or users directly to AdsOne using the Report button on the ad.",
    ],
  },
];

function SafetyTipsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Stay Safe</p>
            <h1 className="info-page__title">Safety Tips for Buyers &amp; Sellers</h1>
            <p className="info-page__subtitle">
              AdsOne is committed to a safe marketplace. Follow these guidelines to protect yourself when buying or selling a vehicle.
            </p>
          </div>

          {/* Tips */}
          <div className="info-page__body">
            {TIPS.map((tip, i) => (
              <div key={i} className="info-section">
                <div className="info-section__icon-wrap">{tip.icon}</div>
                <div className="info-section__content">
                  <h3 className="info-section__title">{tip.title}</h3>
                  <ul className="info-section__list">
                    {tip.points.map((p, j) => (
                      <li key={j}>
                        <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="info-page__cta">
            <h3>See something suspicious?</h3>
            <p>Report it immediately. Our team reviews all reports and takes action to keep the platform safe.</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SafetyTipsPage;
